/**
 * Created by dannyr on 13/12/2016.
 */

import React from "react";

import { chosenSites } from "app/common/services/chosenSites";

type Item = {
    Key: string;
    Value: string;
};

export interface WaSearchUrlTooltipContentProps {
    data?: Array<Item>;
}

export class WaSearchUrlTooltipContent extends React.Component<WaSearchUrlTooltipContentProps> {
    static defaultProps = { data: [] };

    constructor(props: WaSearchUrlTooltipContentProps) {
        super(props);
    }

    private getOutsideLink(item: Item) {
        if (item.Value.indexOf("http") === 0) {
            return item.Value;
        } else {
            return "http://" + item.Value;
        }
    }

    render() {
        const items = [];
        // @ts-ignore FIXME: strict migration - this.props.data is optional but defaultProps guarantees [] at runtime
        for (let i = 0; i < this.props.data.length; i++) {
            // @ts-ignore FIXME: strict migration - this.props.data is optional but defaultProps guarantees [] at runtime
            const item = this.props.data[i];
            const url = item.Value;
            const site = item.Key;
            const hasValue = item.Value.toLowerCase() !== "n/a";
            const isFirst = i == 0;
            // @ts-ignore FIXME: strict migration - this.props.data is optional but defaultProps guarantees [] at runtime
            const isLast = i == this.props.data.length - 1;
            const color = chosenSites.getSiteColor(site);
            const padding = isFirst ? "0 0 10px 0" : isLast ? "10px 0 0 0" : "10px 0";
            items.push(
                <div
                    key={item.Key}
                    style={{
                        borderBottom: !isLast ? "2px solid #F8F8F8" : "none",
                        padding: padding,
                    }}
                >
                    <div style={{ verticalAlign: "top", display: "inline-block" }}>
                        <span
                            className="legend-item-circle"
                            style={{ background: color, marginRight: 5 }}
                        />
                        <span
                            style={{
                                display: "inline-block",
                                width: "120px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                verticalAlign: "bottom",
                                marginRight: "10px",
                            }}
                        >
                            {item.Key}
                        </span>
                    </div>
                    {hasValue ? (
                        <span className="tooltip-link">
                            {item.Value}
                            <a
                                className="swTable-linkOut sw-link-out"
                                href={this.getOutsideLink(item)}
                                target="_blank"
                                rel="noreferrer"
                            />
                        </span>
                    ) : (
                        <span className="tooltip-link"> - </span>
                    )}
                </div>,
            );
        }
        return <div>{items}</div>;
    }
}
